The URL of the dark mode image to indicate candidate identity has been verified.
